// extracted by mini-css-extract-plugin
export var backButton = "backButton-module--back-button--55ISB";
export var backIcon = "backButton-module--back-icon--bb-rO";